<template>
    <v-card max-width="700" min-width="400">
        <v-list-item three-line>
            <v-list-item-content>
                <v-card-title>{{ "Edit active redirect banks" | t }}</v-card-title>
                <v-card-subtitle
                    >{{ "Here you can edit what redirect bank is currently activated" | t }}
                </v-card-subtitle>
                <v-card-text v-if="activeCompanyBanks" class="asc-banks-list">
                    <div v-for="(item, index) in activeCompanyBanks" :key="item.swift">
                        <v-row class="align-center">
                            <v-col class="pt-0 pb-0">
                                <img :alt="item.name + '_logo'" :src="assets_url + '/img/banks/' + item.swift + '.svg'"
                            /></v-col>
                            <v-col class="pt-0 pb-0">
                                <v-col class="pb-0 subtitle-1">{{ "Swift" | t }}:</v-col>
                                <v-col class="pt-0 ">{{ item.swift ? item.swift : "-" }}</v-col>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                                <v-col class="pb-0 subtitle-1">{{ "Status" | t }}:</v-col>
                                <v-col class="pt-0"
                                    ><v-switch
                                        class="ma-0"
                                        v-model="item.status"
                                        color="primary"
                                        :value="item.status !== 'active'"
                                        @change="updateStatus(index, item.status)"
                                /></v-col>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions>
            <v-spacer />
            <v-btn color="black" text @click="handleSaveClick">
                {{ "Save" | t }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import settings from "@/settings";
import Store from "@/store";
export default {
    name: "redirect-banks-edit-card",
    data() {
        return {
            assets_url: settings.assets_url,
            statuses: ["active", "inactive"]
        };
    },
    async mounted() {
        if (!this.activeCompanyBanks) await this.getAvailableBanks();
    },
    computed: { ...mapState(["activeCompanyBanks"]) },
    methods: {
        ...mapActions(["submitAvailableBanks", "getAvailableBanks"]),
        async handleSaveClick() {
            let result = await this.submitAvailableBanks(this.activeCompanyBanks);
            if (result) {
                this.$router.push({ name: "general-settings-view" });
                Store.commit("setRequestSuccess", true);
            }
        },
        updateStatus(index, status) {
            Store.commit("updateActiveCompanyBankProperty", {
                prop: "status",
                value: status ? "active" : "inactive",
                index: index
            });
        }
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
